import {
  WATERFALL_QUERY_PARAM_CAP_TABLE_VERSION,
  WATERFALL_QUERY_PARAM_CURRENCY_FORMAT,
  WATERFALL_QUERY_PARAM_EXIT_DATE,
  WATERFALL_QUERY_PARAM_EXIT_ENTERPRISE_VALUE,
  WATERFALL_QUERY_PARAM_EXIT_EQUITY_VALUE,
  WATERFALL_QUERY_PARAM_FOREIGN_CURRENCY,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE_INPUT_CURRENCY,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE_OVERRIDDEN,
  WATERFALL_QUERY_PARAM_LESS_DEBT,
  WATERFALL_QUERY_PARAM_PLUS_CASH,
  WATERFALL_QUERY_PARAM_VIEW,
} from 'pages/Waterfall/constants';

// Params directly tied to waterfall calculation inputs are cleared when leaving the waterfalls tab.
// Measurement date ('date'), export mode, and pagination params are intentionally preserved.
export const WATERFALL_CALCULATION_SEARCH_PARAMS: string[] = [
  WATERFALL_QUERY_PARAM_CAP_TABLE_VERSION,
  WATERFALL_QUERY_PARAM_EXIT_EQUITY_VALUE,
  WATERFALL_QUERY_PARAM_EXIT_ENTERPRISE_VALUE,
  WATERFALL_QUERY_PARAM_EXIT_DATE,
  WATERFALL_QUERY_PARAM_PLUS_CASH,
  WATERFALL_QUERY_PARAM_LESS_DEBT,
  WATERFALL_QUERY_PARAM_FOREIGN_CURRENCY,
  WATERFALL_QUERY_PARAM_CURRENCY_FORMAT,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE_OVERRIDDEN,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE_INPUT_CURRENCY,
  WATERFALL_QUERY_PARAM_VIEW,
  'company', // firm-page company selector (no shared constant exists)
];

export const removeWaterfallCalculationQueryParams = (queryParams: Record<string, unknown>): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(queryParams).filter(([param]) => !WATERFALL_CALCULATION_SEARCH_PARAMS.includes(param))
  );

export const stripWaterfallCalculationSearchParams = (search: string): string => {
  const params = new URLSearchParams(search);
  WATERFALL_CALCULATION_SEARCH_PARAMS.forEach(param => params.delete(param));
  return params.size > 0 ? `?${params.toString()}` : '';
};
